import { SetOwner } from '@adaptiva/core/common';
import { provideBaseWidget } from '@adaptiva/core/widgets';
import { BaseEditorError, EEditorErrorType, IBaseEditorError } from '@adaptiva/data-service';
import { ComboComponent } from '@adaptiva/widgets/combo';
import { InputComponent } from '@adaptiva/widgets/input';
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { BaseScheduleTypeComponent } from '../base-schedule-type.component';

@Component({
	standalone: false,
	selector: 'app-recurring-by-week',
	templateUrl: './recurring-by-week.component.html',
	providers: [provideBaseWidget(() => RecurringByWeekComponent)],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecurringByWeekComponent extends BaseScheduleTypeComponent {

	@ViewChild('RecurringIntervalInWeeksInput')
	@SetOwner recurringIntervalInWeeksInput: InputComponent;

	@ViewChild('DayOfTheWeekInput')
	@SetOwner dayOfTheWeekInput: ComboComponent;

	public numberOfWeeks = 1;

	public dayOfWeek = 0;

	public dayOptions = [
		{ display: 'Sunday', value: 0 },
		{ display: 'Monday', value: 1 },
		{ display: 'Tuesday', value: 2 },
		{ display: 'Wednesday', value: 3 },
		{ display: 'Thursday', value: 4 },
		{ display: 'Friday', value: 5 },
		{ display: 'Saturday', value: 6 }
	];

	public validate(): IBaseEditorError[] {
		const _errors: IBaseEditorError[] = [];

		if (this.numberOfWeeks < 1) {
			_errors.push(
				new BaseEditorError(
					EEditorErrorType.Error,
					this.guid,
					['RecurringIntervalInWeeksInput', 'Number of weeks must be greater than 0']
				)
			);
		}

		return _errors;
	}

	public commitModelToView(): void {
		if (this.schedule) {
			this.numberOfWeeks = +this.schedule.numberOfWeeks;

			if (this.recurringIntervalInWeeksInput)
				this.recurringIntervalInWeeksInput.setValue(this.numberOfWeeks);

			this.dayOfWeek = +this.schedule.dayOfWeek;
			this.dayOfTheWeekInput?.setValue(this.dayOfWeek);
		}
	}

	// event listeners start
	setNumberOfWeeks(event: string) {
		const weeks = +event;

		if (weeks !== this.numberOfWeeks) {
			this.numberOfWeeks = +event;
			this.outputChanges([
				{ propertyName: 'numberOfWeeks', value: this.numberOfWeeks }
			]);
		}
	}

	setDayOfWeek(event: any) {
		const days = +event;

		if (days !== this.dayOfWeek) {
			this.dayOfWeek = +event;
			this.outputChanges([
				{ propertyName: 'dayOfWeek', value: this.dayOfWeek }
			]);
		}
	}
	// event listeners end

}
